<template>
  <div class="wrap">
    <div class="inner">
      <div class="banner">
        <h1>稳定&便宜的大模型API接口</h1>
        <p>
          GPT-4、Claude-3是官网价格的<strong>50%</strong>，其余AI接口折扣请联系客服咨询
        </p>
        <a href="" @click.prevent="wxDialogShow=true">立即申请</a>
      </div>

      <div class="pricing">
        <h2><el-divider class="title">模型价格</el-divider></h2>
        <table class="pricing-table">
          <thead>
            <tr>
              <th>模型名称</th>
              <th>输入价格</th>
              <th>输出价格</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>GPT-4 Turbo</td>
              <td>
                <span class="price">$0.005</span
                ><span class="fake_price">(0.01)</span> / 1K tokens
              </td>
              <td>
                <span class="price">$0.015 </span
                ><span class="fake_price">(0.03)</span> / 1K tokens
              </td>
            </tr>
            <tr>
              <td>GPT-4</td>
              <td>
                <span class="price">$0.015</span
                ><span class="fake_price">(0.03)</span> / 1K tokens
              </td>
              <td>
                <span class="price">$0.03</span
                ><span class="fake_price">(0.06)</span> / 1K tokens
              </td>
            </tr>
            <tr>
              <td>GPT-3.5 Turbo</td>
              <td>
                <span class="price">$0.00025</span
                ><span class="fake_price">(0.0005)</span> / 1K tokens
              </td>
              <td>
                <span class="price">$0.00075</span
                ><span class="fake_price">(0.0015)</span> / 1K tokens
              </td>
            </tr>
            <tr>
              <td>Claude-3 Opus</td>
              <td>
                <span class="price">$0.0075</span
                ><span class="fake_price">(0.015)</span> / 1K tokens
              </td>
              <td>
                <span class="price">$0.0375</span
                ><span class="fake_price">(0.075)</span> / 1K tokens
              </td>
            </tr>
            <tr>
              <td>Claude-3 Sonnet</td>
              <td>
                <span class="price">$0.0015</span
                ><span class="fake_price">(0.003)</span> / 1K tokens
              </td>
              <td>
                <span class="price">$0.0075</span
                ><span class="fake_price">(0.015)</span> / 1K tokens
              </td>
            </tr>
            <tr>
              <td>Claude-3 Haiku</td>
              <td>
                <span class="price">$0.000125</span
                ><span class="fake_price">(0.00025)</span> / 1K tokens
              </td>
              <td>
                <span class="price">$0.000625</span
                ><span class="fake_price">(0.00125)</span> / 1K tokens
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pricing-tip">其他模型价格请咨询客服</div>
      </div>

      <div class="models">
        <h2><el-divider class="title">可用模型</el-divider></h2>
        <ul class="models-list">
            <li v-for="item in models" :key="item">{{ item }}</li>
        </ul>
      </div>

      <div class="faq" v-if="false">
        <h2><el-divider class="title">常见问题</el-divider></h2>
        <div class="faq-list">
        <div class="faq-item">
          <strong class="question">为什么GPT、Claude接口比官网便宜？</strong>
          <p class="answer">GPT接口适用于给中小型AI团队使用，并不是海量免费账号实现的，Beta版本支持每秒调用30次，速度与官网一致。请放心使用，希望Beta版本能帮助开发者更低成本的启动项目。 </p>
        </div>
        <div class="faq-item">
          <strong class="question">如何使用ManyAI服务？</strong>
          <p class="answer">
            你可以点击「立即申请」扫描客服微信二维码并添加好友，添加完成后客服会帮助您完成后续操作。
          </p>
        </div>
        <div class="faq-item">
          <strong class="question">ManyAI支持哪些地区？</strong>
          <p class="answer">
            受限于地方法律法规，ManyAI不支持中国大陆的服务器IP访问，禁止用户在中国境内提供GPT服务。除此之外的地区，ManyAI均能正常提供服务，访问速度与官网一致。
          </p>
        </div>
    </div>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" class="common-dialog" :width="isMobile?'90%':'402px'" :visible.sync="wxDialogShow">
        <div class="wx-content">
            <div class="hd">请添加客服微信完成定制内容</div>
            <div class="bd">
                <img src="@/assets/images/new/kf.jpg" class="qrcode" >
                <p>微信扫一扫，联系客服</p>
            </div>
            <a href="" class="btn" @click.prevent="wxDialogShow=false">知道了</a>
        </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      wxDialogShow: false,
      models: [
        "360GPT_S2_V9",
        "babbage-002",
        "Baichuan-Text-Embedding",
        "Baichuan2-Turbo",
        "Baichuan2-Turbo-192k",
        "chatglm_lite",
        "chatglm_pro",
        "chatglm_std",
        "chatglm_turbo",
        "claude-2",
        "claude-2.0",
        "claude-2.1",
        "claude-3-haiku-20240307",
        "claude-3-opus-20240229",
        "claude-3-sonnet-20240229",
        "claude-instant-1",
        "code-davinci-edit-001",
        "code-llama-13b",
        "code-llama-34b",
        "code-llama-7b",
        "dall-e-2",
        "dall-e-3",
        "davinci-002",
        "embedding-bert-512-v1",
        "Embedding-V1",
        "embedding_s1_v1",
        "ERNIE-Bot",
        "ERNIE-Bot-4",
        "ERNIE-Bot-turbo",
        "file-upload",
        "gemini-pro",
        "gemini-pro-vision",
        "gemma-7b-it",
        "glm-3-turbo",
        "glm-4",
        "glm-4v",
        "google-palm",
        "gpt-3.5-turbo",
        "gpt-3.5-turbo-0125",
        "gpt-3.5-turbo-0301",
        "gpt-3.5-turbo-0613",
        "gpt-3.5-turbo-1106",
        "gpt-3.5-turbo-16k",
        "gpt-3.5-turbo-16k-0613",
        "gpt-3.5-turbo-instruct",
        "gpt-4",
        "gpt-4-0125-preview",
        "gpt-4-0314",
        "gpt-4-0613",
        "gpt-4-1106-preview",
        "gpt-4-32k",
        "gpt-4-32k-0314",
        "gpt-4-32k-0613",
        "gpt-4-all",
        "gpt-4-gizmo-*",
        "gpt-4-turbo-preview",
        "gpt-4-vision-preview",
        "gpts-get",
        "hunyuan",
        "llama-2-13b",
        "llama-2-70b",
        "llama-2-7b",
        "llama2-70b-4096",
        "mistral-medium",
        "mixtral-8x7b",
        "mixtral-8x7b-32768",
        "moonshot-v1-32k",
        "moonshot-v1-8k",
        "qwen-max",
        "qwen-max-longcontext",
        "qwen-plus",
        "qwen-turbo",
        "search-gpts",
        "search-gpts-chat",
        "semantic_similarity_s1_v1",
        "SparkDesk-v1.1",
        "SparkDesk-v2.1",
        "SparkDesk-v3.1",
        "SparkDesk-v3.5",
        "text-ada-001",
        "text-babbage-001",
        "text-curie-001",
        "text-davinci-002",
        "text-davinci-003",
        "text-davinci-edit-001",
        "text-embedding-3-large",
        "text-embedding-3-small",
        "text-embedding-ada-002",
        "text-embedding-v1",
        "text-moderation-latest",
        "text-moderation-stable",
        "tts-1",
        "tts-1-1106",
        "tts-1-hd",
        "tts-1-hd-1106",
        "whisper-1",
      ],
    };
  },
};
</script>

<style scoped lang="less">
.wrap {
  padding: 60px 15px 50px;
  background-color: #fff;
}
.banner {
  margin-top: 45px;
  text-align: center;
  h1 {
    font-size: 35px;
    font-weight: 600;
    color: #232d36;
  }
  p {
    font-size: 21px;
    font-weight: 600;
    color: #989a9d;
    margin-bottom: 36px;
    strong {
      font-weight: 600;
      font-size: 30px;
      color: #232d36;
    }
  }
  a {
    display: block;
    margin: 0 auto;
    width: 134px;
    height: 44px;
    border-radius: 8px;
    text-align: center;
    background-color: var(--color-1);
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    line-height: 44px;
  }
}
.title {
  width: 280px;
  margin: 80px auto 25px;
  background-color: #232d36;
  /deep/ .el-divider__text {
    font-weight: 500;
    font-size: 18px;
    color: #232d36;
  }
}
.pricing-table {
  max-width: 780px;
  margin: 0 auto;
  th {
    color: #76787d;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    padding: 6px;
    border-bottom: 1px solid #ebedef;
  }
  td {
    color: #76787d;
    font-size: 16px;
    text-align: center;
    padding: 8px 20px;
    border-bottom: 1px solid #ebedef;
  }
  .price {
    color: #ff1f00;
  }
  .fake_price {
    text-decoration: line-through;
  }
}
.pricing-tip {
    font-size: 16px;
    text-align: center;
    color: #989A9D;
    padding-top: 15px;
}
.models-list {
    max-width: 950px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    li {
        color: #76787D;
        font-size: 14px;
        padding: 4px 8px;
        background-color: #F6F6F6;
        border-radius: 4px;
        margin-left: 4px;
        margin-bottom: 4px;
    }
}
.faq-list {
    max-width: 547px;
    margin: 0 auto;
}
.faq-item {
    box-shadow: 0px 4px 14.1px 0px #D7D7D840;
    border-radius: 12px;
    margin-bottom: 12px;
    padding: 18px 30px;
    .question {
        color: #232D36;
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 10px;
        display: block;
    }
    .answer {
        color: #76787D;
        font-size: 14px;
    }
}

.wx-content {
    padding: 30px;
    .hd {
        font-size: 18px;
        font-weight: 500;
        color: #EE5A53;
        text-align: center;
        margin-bottom: 20px;
    }
    .bd {
        text-align: center;
        margin-bottom: 23px;
        p {
            font-size: 14px;
            color: #989A9D;
        }
    }
    .qrcode {
       width: 114px;
    }
    .btn {
        display: block;
        margin: 0 auto;
        width: 224px;
        height: 34px;
        text-align: center;
        border-radius: 8px;
        background: var(--color-1);
        color: #fff;
        font-size: 14px;
        line-height: 34px;
    }
}
@media only screen and (max-width: 800px) {
    .banner h1 {
        font-size: 24px;
        margin-bottom: 5px;
    }
    .banner p {
        font-size: 16px;
    }
    .banner p strong {
        font-size: 18px;
    }
    .title {
        margin-top: 50px;
    }
    .title /deep/ .el-divider__text {
        font-size: 16px;
    }
    .pricing-table th, .pricing-table td {
        font-size: 13px;
        padding: 4px 2px;
    }
    .pricing-tip {
        font-size: 14px;
    }
    .models-list li {
        font-size: 13px;
    }
    .faq-item {
        padding: 10px 15px;
    }
    .wx-content {
      padding: 25px;
    }
}
</style>
